import { Loading } from "@/components/Loading/Loading";
import { withAuthenticationRequired } from "@auth0/auth0-react";
import React, { ReactNode, Suspense } from "react";

interface AuthGuardProps {
  component: ReactNode | (() => JSX.Element);
  protectedRoute?: boolean;
}

export const AuthGuard: React.FC<AuthGuardProps> = ({ component }) => {
  const componentAsFunc = (): JSX.Element => {
    return <>{component}</>;
  };

  const wrappedComponent = typeof component === "function" ? (component as () => JSX.Element) : componentAsFunc;

  const Component = withAuthenticationRequired(wrappedComponent, {
    onRedirecting: () => <Loading />
  });
  return (
    <Suspense fallback={<Loading />}>
      <Component />
    </Suspense>
  );
};
